import { Collapse } from '@chakra-ui/react'
import React from 'react'
import { useWatch } from 'react-hook-form'

const Dependent = ({ control, when, children }) => {
  const value = useWatch({ control, name: when[0] })
  return (
    <Collapse in={typeof when[1] === 'boolean' ? value : value == when[1]} unmountOnExit>
      {children}
    </Collapse>
  )
}

export default Dependent
